<template>
		<div class="swiper-container">
			<ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
			<!-- Additional required wrapper -->
			<div class="swiper-wrapper">
				<!--Portada General-->

				<!--INICIO SLIDE-1-->
				<div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Referencias bibliográficas">
					<div class="container-fluid">
						<div class="row fondoReferencias d-flex justify-content-center">
							<div class="col-lg-8 col-md-12 col-sm-8 col-xs-12 fondoblancoref">
								<div class="ml-md-5 mr-md-5 ml-sm-3 mb-5">	
									<h2 class="mt-4 ml-xl-0 ml-lg-0 ml-2">Referencias bibliográficas</h2>
									<div class="ml-md-0 mr-md-0 ml-2 ml-sm-3 mb-5 h-100">
											<ul class="mt-4">			

											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Amar, J., Abello, R. y Tirado, D. (2007). <span class="font-italic">Desarrollo infantil y construcción del mundo social.</span> Barranquilla: Uninorte.</p></li>	



											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Bruner, J. (1989). <span class="font-italic">Acción, pensamiento y lenguaje. Madrid: </span>Alianza.</p></li>	

											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0"> Chomsky, N. (1979). Reflexiones sobre el lenguaje. España: Ariel.Halliday, M. (1978). <span class="font-italic">El lenguaje como semiótica social.</span> Ciudad de México: Fondo de Cultura Económica.</p></li>	


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Linares, R. (2005). Desarrollo cognitivo: .<span class="font-italic">Las teorías de Piaget y Vigotsky.</span> Barcelona: Universitar Autónoma de Barcelona</p></li>	


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Master 1405 (2020). Pedagogía e infancia [fotografía]. Recuperada de <a href="https://www.freepik.es/foto-gratis/ninos-jugando-rompecabezas-mosaico_9264809.htm#page=1&query=desarrollo%20ni%C3%B1os&position=8">https://www.freepik.es/foto-gratis/ninos-jugando-rompecabezas-mosaico_9264809.htm#page=1&query=desarrollo%20ni%C3%B1os&position=8
</a> <span class="font-italic"></span></p></li>	

											
											
											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Montealegre, R. (2014). Controversias Piaget-Vygotsky en Psicología del desarrollo. <span class="font-italic">Acta colombiana de psicología</span>, pp. 270-283.</p></li>	


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Mussen, P. (1970). Piaget's Theory. .<span class="font-italic">En Carmichael's manual of child psychology.</span>Nueva York: John Wiley Sons Inc</p></li>


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Niño, V. (2007). <span class="font-italic">Fundamentos de Semiótica y Lingüística.</span> Bogota: Ecoe Ediciones.</p></li>


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Perinat, A. (2004). <span class="font-italic">Psicología del desarrollo: un enfoque sistémico.</span> Barcelona: Editorial UOC.</p></li>


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Piaget, J. (2007).<span class="font-italic">Seis estudios de psicología.</span>  Barcelona: Labor.</p></li>	


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Piaget, J. e Inhelder, B. (1969). <span class="font-italic">Psicología del niño.</span> Madrid: Morata.</p></li>


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Rousseau, J. J. (1985). <span class="font-italic">Emilio.</span> México: Edaf.</p></li>


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Searle, J. (1969). <span class="font-italic">Actos de Habla.</span> Barcelona: Planeta-Agostini.</p></li>	


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Vygotsky, L. (2009). <span class="font-italic">El desarrollo de los procesos psicológicos superiores.</span> Crítica: Barcelona.</p></li>	


											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Vygotsky, L. (2013). <span class="font-italic">Pensamiento y lenguaje.</span> Madrid: Grupo Planeta.</p></li>	
												
												
										</ul>
										
									</div>
									<h3 class="mt-4 ml-xl-0 ml-lg-0 ml-2">Lecturas complementarias</h3>
									<div class="ml-md-0 mr-md-0 ml-2 ml-sm-3 mb-5 h-100">
										<ul class="mt-4">											
											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Freud, S. (1978). <span class="font-italic">Fragmento de análisis de un caso de histeria: tres ensayos de teoría sexual y otras obras</span>. Buenos Aires: Amorrotu.</p></li>	
											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Freud, S. (1978). <span class="font-italic">La organización genital infantil (una interpolación en la teoría de la sexualidad)</span>,. Buenos Aires: Amorrortu.</p></li>	
											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Freud, S. (2004). <span class="font-italic">Sexualidad infantil y neurosis</span>. Barcelona: Alianza.</p></li>	
											<li class="d-flex"><div><span class="i-check mr-2 Radiobutton checkRef"></span></div><p class="mb-0 pb-0">Leliwa , S. y Scangarello, I. (2016). <span class="font-italic">Psicología y Educación</span>. Córdoba: Editorial Brujas.</p></li>	
										</ul>
									</div>
								</div>														
							</div>
							<div class=" col-lg-4 col-md-12 col-sm-4 col-12">
								
								<div class="referenciascontenido position-fixed d-none d-lg-block">
									<img src="recursos/img/icon-book.png" class=" img-fluid" alt="">
								</div>
							</div>						
						</div>
					</div>
				</div>
				<!--FIN SLIDE-1-->

			</div>
		</div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'ReferenciasBibliograficas',
    mounted() {
        SwiperController(), // Cargar controladores de Swiper
        document.title = this.$route.meta.title // Cambiar el título de la página
    },
}
</script>